import Transition from '@ember/routing/-private/transition';
import Route from 'cio/routes/base';
import FeaturesService from 'ember-feature-flags/services/features';
import { inject as service } from '@ember/service';
import SubscriptionCenterService from 'cio/services/subscription-center';
import SubscriptionCenterBrandingEditController from 'cio/pods/workspace-settings/subscription-center/branding-edit/controller';
import ConfirmChangesService from 'cio/services/confirm-changes';
import EnvironmentService from 'cio/services/environment';
import { LogoSource, SubscriptionCenterNavTabs } from 'cio/utils/subscription-center';
import AccountService from 'cio/services/account';
import { WHITE, PURPLE_700 } from 'cio/utils/colors';

const DEFAULT_BACKGROUND_COLOR = PURPLE_700;
const DEFAULT_FOREGROUND_COLOR = WHITE;
export default class SubscriptionCenterBrandingEditRoute extends Route {
  @service features!: FeaturesService;
  @service subscriptionCenter!: SubscriptionCenterService;
  @service confirmChanges!: ConfirmChangesService;
  @service environment!: EnvironmentService;
  @service account!: AccountService;

  crumb() {
    return [
      {
        name: 'Settings',
        path: 'workspace-settings.subscription_center.settings',
      },
      {
        name: 'Branding',
        path: this.routeName,
      },
    ];
  }

  async beforeModel(transition: Transition) {
    await this.subscriptionCenter.initializeTask.perform();
    return super.beforeModel(transition);
  }

  async setupController(controller: SubscriptionCenterBrandingEditController, model: null, transition: Transition) {
    super.setupController(controller, model, transition);
    this.confirmChanges.register(controller, this);

    let settings = await this.environment.current.getSubscriptionCenter({});
    let { logoPath } = settings;

    if (settings.logoSource === LogoSource.Account) {
      logoPath = this.account.current.logoUrl;
    }

    controller.brandingValues = {
      ...settings,
      backgroundColor: settings.backgroundColor ?? DEFAULT_BACKGROUND_COLOR,
      foregroundColor: settings.foregroundColor ?? DEFAULT_FOREGROUND_COLOR,
      logoSource: settings.logoSource ?? LogoSource.None,
      logoPath,
    };

    controller.savedBrandingValues = { ...controller.brandingValues };
    controller.activeTab = this.subscriptionCenter.enabled
      ? SubscriptionCenterNavTabs.Topics
      : SubscriptionCenterNavTabs.GlobalUnsubscribe;
  }

  resetController(controller: SubscriptionCenterBrandingEditController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);
    if (isExiting) {
      controller.resetDefaults();
    }
  }
}
